module.exports = __webpack_public_path__ + "static/media/oracular-spetacular.1db83401.jpg";